module.exports = __webpack_public_path__ + "static/media/order-plates.2a83c224.png";